<template>
	<div :class="{ empty: 1, 'empty--background': background }">
		<svg v-if="icon" class="empty--background__icon" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 172 172"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none" stroke="none"></path><g><path d="M10.75,161.25v-130.2599l20.2401,-20.2401h110.0198l20.2401,20.2401v130.2599z" fill="" stroke="none"></path><path d="M140.1198,12.9l18.9802,18.9802v127.2198h-146.2v-127.2198l18.9802,-18.9802h108.2396M141.9,8.6h-111.8l-21.5,21.5v133.3h154.8v-133.3l-21.5,-21.5z" fill="var(--line-11)" stroke="none"></path><path d="M139.75,32.25v-21.5h1.2599l20.2401,20.2401v1.2599z" fill="var(--black-dark-10)" stroke="none"></path><path d="M141.9,14.6802l15.4198,15.4198h-15.4198v-15.4198M141.9,8.6h-4.3v25.8h25.8v-4.3l-21.5,-21.5z" fill="var(--line-11)" stroke="none"></path><path d="M10.75,32.25v-1.2599l20.2401,-20.2401h1.2599v21.5z" fill="var(--black-dark-10)" stroke="none"></path><path d="M30.1,14.6802v15.4198h-15.4198l15.4198,-15.4198M34.4,8.6h-4.3l-21.5,21.5v4.3h25.8v-25.8z" fill="var(--line-11)" stroke="none"></path><path d="M8.6,32.25h154.8" fill="none" stroke="var(--line-11)"></path><g fill="var(--line-11)" stroke="none"><path d="M103.2,51.6h-17.2h-17.2c-2.3736,0 -4.3,1.9264 -4.3,4.3c0,2.3736 1.9264,4.3 4.3,4.3h17.2h17.2c2.3736,0 4.3,-1.9264 4.3,-4.3c0,-2.3736 -1.9264,-4.3 -4.3,-4.3z"></path></g><g stroke="none"><path d="M32.25,10.75h107.5v21.5h-107.5z" fill="var(--black-dark-10)"></path><path d="M137.6,12.9v17.2h-103.2v-17.2h103.2M141.9,8.6h-111.8v25.8h111.8v-25.8z" fill="var(--line-11)"></path></g></g></g></svg>
		<span class="empty__message">{{ message }}</span>
		<slot name="action" />
	</div>
</template>
<script>
export default {
	name: "empty",
	props: {
		background: Boolean,
		message: {
			type: String,
			default: "An error occurred, please try again",
		},
		icon: {
			Boolean,
			default: false
		}
	},
};
</script>
<style lang="scss">
.empty {
	padding: 20px;
	margin: 10px auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	border-radius: 5px;
	color: var(--light-black);
	&__message {
		margin-top: 5px;
		text-align: center;
		font-size: var(--font-small);
	}
	&--background{
		&__icon {
			width:50px;
		}
	}
}
</style>
